<div class="sidebar d-flex flex-column justify-content-between">
    <div class="sidbar-top d-flex flex-column">
        <div class="app-start" *ngFor="let app of apps; let i = index">
            <div class="inner-app-start">
                <a  class="app-start-link d-flex justify-content-center align-items-center" [routerLink]="[app['path']]" routerLinkActive="active">
                    <span class="app-name" [innerHTML]="app['name']"></span>
                </a>
            </div>
        </div>
    </div>
    <div class="sidebar-bottom d-flex flex-column">
        <a [routerLink]="['/profile']" class="d-flex justify-content-center align-items-center link link-profile" routerLinkActive="active">
            <i class="fa fa-user-circle-o" aria-hidden="true"></i>
        </a>
        <a class="link link-support d-flex justify-content-center align-items-center mt-3 mb-3" href="https://support.flyingspoon.de/" target="_blank">
            <img src="assets/image/btn_helpdesk.png" alt="">
        </a>
    </div>
</div>